import { configureStore } from "@reduxjs/toolkit";
import signUpSlice from "../components/signUp/cl_SignUpSlice";
import accountHistorySlice from "../components/accountHistory/cl_AccountHistorySlice";
import betHistorySlice from "../components/betHistory/cl_BetHistory.Slice";
import bonusHistorySlice from "../components/bonusHistory/cl_BonusHistorySlice";
import messageCnterSlice from "../components/messageCenter/cl_MessageCenterSlice";
import signInSlice from "../components/signIn/cl_SignInSlice";
import accountDetialsSlice from "../components/accountDetails/cl_AccountDetailsSlice";
import crashGames from "../components/crashGames/cl_CrashSlice";
import resetSlice from "../components/resetpage/cl_ResetSlice";
import changePinSlice from "../components/changePin/cl_ChangePinSlice";
import myBetsSlice from "../components/myBets/cl_MyBets";
import SetNewPinSlice from "../components/resetpage/cl_SetNewPinSlice";
import responibleGambling from "../components/responsibleGambling/cl_ResponsibleGambling";
import paymentSlice from "../components/deposit/cl_payment";
import bannersSlice from "../components/banners/cl_Banners";
import withdrawSlice from "../components/withdraw/cl_withdraw";
import coinsHistorySlice from "../components/home/cl_LoyalltyCoins";
import bonusUsageSlice from "../components/bonusUsage/cl_BonusUsage";
import  footerSlice  from "../components/common/Footer/cl_footerSlice";
import  bottomMenuSlice  from "../components/home/BottomMenu/cl_bottomMenu";
import  topGamesListSlice  from "../components/home/TopGamesList/cl_topGamesList";
import  promotionSlice  from "../components/common/Promotions/cl_promotionSlice";
import  aboutSlice  from "../components/common/About/cl_aboutSlice";
import chatbotSlice from "../components/chatbot/cl_ChatbotSlice";

export const store = configureStore({
    reducer: {
        signUp: signUpSlice,
        signIn: signInSlice,
        setNewPin: SetNewPinSlice,
        resetPage: resetSlice,
        accountHistory: accountHistorySlice,
        betHistory: betHistorySlice,
        bonusHistory: bonusHistorySlice,
        messages: messageCnterSlice,
        crash: crashGames,
        accountDetails: accountDetialsSlice,
        changepin: changePinSlice,
        mybets: myBetsSlice,
        responibleGambling: responibleGambling,
        payment:paymentSlice,
        withdraw: withdrawSlice,
        banners: bannersSlice,
        coinsHistory: coinsHistorySlice,
        bonusUsage: bonusUsageSlice,
        footer:footerSlice,
        bottomMenu:bottomMenuSlice,
        topGamesList:topGamesListSlice,
        promotion:promotionSlice, 
        about:aboutSlice,
        chatbot: chatbotSlice,
    },
});

// Make store available globally for getUserIdFromState function
if (typeof window !== 'undefined') {
  window.__store__ = store;
}
